import { Hire } from "./Hire.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  Hire
};
//# sourceMappingURL=index.js.map
